import { useState, useEffect } from "react";
import { getRelatedArticles } from "@helpers";

import * as components from "@components";
import clsx from "clsx";

export default function News({ tag }) {
    const [productArticles, setProductArticles] = useState([]);
    const [cards, setCards] = useState([]);

    useEffect(() => {
        getRelatedArticles(tag).then((articles) => {
            setProductArticles(articles);
        });
    }, [tag]);

    useEffect(() => {
        const newCards = productArticles.map((article) => ({
            title: article.title,
            subheader: article.summary,
            img: article.image_url,
            imgAlt: "",
            link: `/news/${article.uri}`,
            linkDisplayText: "Read Articles",
        }));

        setCards(newCards);
    }, [productArticles]);

    return (
        <div className={parentContainer}>
            <components.UnderlinedSectionHeader className="mb-10">
                News
            </components.UnderlinedSectionHeader>
            {cards.length > 0 ? (
                <components.CarouselCards cards={cards} />
            ) : (
                <components.NoCard product={tag} />
            )}
        </div>
    );
}

const parentContainer = clsx(
    "mt-20 flex w-full flex-col items-center md:mt-40",
);
